import { defineMessages } from 'react-intl';

export default defineMessages({
  missionTitleTable: {
    id: 'manager.missions.table.title',
  },
  missionNumber: {
    id: 'expertise.table_header_titles.missionNumber',
  },
  appointedExpert: {
    id: 'expertise.table_header_titles.appointedExpert',
  },
  type: {
    id: 'expertise.table_header_titles.type',
  },
  missionDate: {
    id: 'expertise.table_header_titles.missionDate',
  },
  concernedParty: {
    id: 'expertise.table_header_titles.concerned_party',
  },
  missionStatus: {
    id: 'expertise.table_header_titles.missionStatus',
  },
  claimNumber: {
    id: 'expertise.table_header_titles.claimNumber',
  },
  rowsPerPage: {
    id: 'court_manager_page.assigned_claims_table.lines_per_page',
  },
  city: {
    id: 'expertise.table_header_titles.city',
  },
  courtNumber: {
    id: 'expertise.table_header_titles.courtNumber',
  },
  procedure: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  step: {
    id: 'expertise.recap_drawer.step',
  },
  expertiseNature: {
    id: 'expertise.recap_drawer.expertiseNature',
  },
  victims: {
    id: 'expertise.recap_drawer.victims',
  },
  cityName: {
    id: 'expertise.recap_drawer.city',
  },
  lawyerAdvice: {
    id: 'expertise.recap_drawer.lawyerAdvice',
  },
  judiciaryExpert: {
    id: 'expertise.recap_drawer.judiciaryExpert',
  },
  hour: {
    id: 'expertise.recap_drawer.hour',
  },
  expertiseAddress: {
    id: 'expertise.recap_drawer.expertiseAddress',
  },
  expert: {
    id: 'expertise.recap_drawer.expert',
  },
  assignExpert: {
    id: 'expertise.recap_drawer.assignExpert',
  },
  missionTitle: {
    id: 'expertise.recap_drawer.missionTitle',
  },
  expertConseilField: {
    id: 'Assign.expert_drawer.Expert_conseil',
  },
  statusTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.status',
  },
  rejectionReason: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.rejection.reason',
  },
  action: {
    id: 'expert_mission.action',
  },
  consult: {
    id: 'expert_mission.consult',
  },
  update: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap.edit_title',
  },
  vehicles: {
    id: 'mission.vehicle_fields.title',
  },
  receiptDateField: {
    id: 'mission.receipt_date.field.title',
  },
  procedureField: {
    id: 'expertise.recap_drawer.procedure',
  },
  statusToastTitle: {
    id: 'assigned_expertise.status.title',
  },
  designationLetter: {
    id: 'designation_letter',
  },
  designationLetterFileName: {
    id: 'designation_letter_file_name',
  },
  secondExaminationLetter: {
    id: 'second_examination_letter.title',
  },
});
